/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SurveyModule } from '../models/SurveyModule';
import type { SurveyModuleRequest } from '../models/SurveyModuleRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminSurveyModuleService {

    /**
     * get list of survey modules
     * @returns any Success
     * @throws ApiError
     */
    public static listAdminSurveyModules({
        surveyJobProfileId,
        limit,
        offset,
        ignorePagination,
    }: {
        /**
         * SurveyJobProfile ID
         */
        surveyJobProfileId?: (number | string | null),
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        ignorePagination?: boolean,
    }): CancelablePromise<{
        rows?: Array<SurveyModule>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/surveyModule',
            query: {
                'surveyJobProfileId': surveyJobProfileId,
                'limit': limit,
                'offset': offset,
                'ignorePagination': ignorePagination,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * create SurveyModule
     * @returns SurveyModule Success
     * @throws ApiError
     */
    public static createSurveyModule({
        requestBody,
    }: {
        requestBody: SurveyModuleRequest,
    }): CancelablePromise<SurveyModule> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/surveyModule',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * update Survey Module Information
     * @returns SurveyModule Success
     * @throws ApiError
     */
    public static updateSurveyModule({
        id,
        requestBody,
    }: {
        /**
         * Survey Module ID
         */
        id: string,
        requestBody: SurveyModuleRequest,
    }): CancelablePromise<SurveyModule> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/admin/surveyModule/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete Survey Module
     * @returns any Success
     * @throws ApiError
     */
    public static deleteSurveyModule({
        id,
    }: {
        /**
         * Survey Module ID
         */
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/surveyModule/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
